// Golden ratio (φ) design tokens: spacing rhythm, type scale and layout splits.
export const PHI = 1.618;

// theme.spacing(n) follows the Fibonacci rhythm 8, 13, 21, 34, 55, 89 (8·φ^(n-1));
// factors up to 1 stay linear so 0.5 → 4px and 0.25 → 2px.
export const goldenSpacing = (factor: number): number => {
  const size = Math.abs(factor);
  const px = size <= 1 ? 8 * size : 8 * Math.pow(PHI, size - 1);
  return Math.sign(factor) * Math.round(px);
};

// Splitting a whole by φ gives a larger part of 61.8% and a smaller part of 38.2%
export const GOLDEN_MAJOR = '61.8%';
export const GOLDEN_MINOR = '38.2%';

// Type scale in rem, stepping by powers of φ
export const TYPE_SCALE = {
  display: 2.618, // φ²
  title: 2.058, // φ^1.5
  heading: 1.618, // φ
  headingCompact: 1.435, // φ^0.75
  subheading: 1.272, // φ^0.5
  lead: 1.128, // φ^0.25
  body: 1,
  small: 0.786, // φ^-0.5
};

// Line heights: body text breathes at φ, headings sit tighter at 2/φ
export const LINE_HEIGHT = {
  body: PHI,
  heading: 1.236,
};

// Readable content widths (Fibonacci numbers)
export const CONTENT_WIDTH = {
  form: 377,
  text: 610,
  page: 987,
};
